// extracted by mini-css-extract-plugin
module.exports = {"content":"ApprovalModal_content__7V_Vv","multipleListings":"ApprovalModal_multipleListings__Nplpx","list":"ApprovalModal_list__1afpg"};